import http from "../http-common";

class WorkflowService {
    saveWorkflow = (data) => http.post("/workflows", data);

    getWorkflows = () => http.get(`/workflows`);

    getWorkflow = (id) => http.get(`/workflows/${id}`);

    updateWorkflow = (id, data) => http.put(`/workflows/${id}`, data);

    deleteWorkflow = (id) => http.delete(`/workflows/${id}`);

    updateWorkflowStatus = (id, data) => http.put(`/workflows/${id}/status`, data);

    getWorkflowJobs = (id) => http.get(`/workflows/${id}/jobs`);
}

export default new WorkflowService();
